import React, { forwardRef } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
`;

interface Props extends React.SVGProps<SVGSVGElement> {
  className?: string;
  fill?: string;
}

export const WarningIcon = forwardRef<SVGSVGElement, Props>(
  ({ className, fill, ...props }, ref) => {
    return (
      <StyledRoot
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        viewBox="0 0 24 24"
        fill={fill ? fill : "var(--alert-color)"}
        ref={ref}
      >
        <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"></path>
      </StyledRoot>
    );
  },
);

WarningIcon.displayName = "WarningIcon";
